export enum SiteType {
	venue = 'venue',
	artist = 'artist',
	login = 'login',
	company = 'company',
	admin = 'admin',
	/* Shared elements of venue sites. Dummy router, doesn't actually exist: */
	shared = 'shared',
}

